module.exports = __webpack_public_path__ + "img/trip_sendai21.85023727.jpg";